import React, {useContext} from "react";
import {useUserContext} from "#app/contexts/useUserContext";

type MAIN_TYPE = ReturnType<typeof useUserContext>

const USER_CONTEXT_INSTANCE: React.Context<any> = React.createContext(Object())

export const UserContext: MAIN_TYPE = Object(USER_CONTEXT_INSTANCE)
export const UserContextProvider = USER_CONTEXT_INSTANCE.Provider

export function customUseUserContext<UserWrapperType>(Context: UserWrapperType): UserWrapperType {
    return Object(useContext(Object(Context)))
}

